//#region Angular Imports

import { StateService } from "@uirouter/angularjs";

//#endregion

//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'
import * as moment from 'moment'

//#endregion

import { Activity } from '../../models/common/activity'
import { Api, LocalDictionaryFactory } from './../api/api.module'
import { BaseGridGridsterController, ScopeBaseGridsterGrid } from '../common/common.base.grid.gridster.controller'
import { ButtonsOptions } from '../common/grid/grid.controller'
import { CommonHelper, DataType, ViewColumnType, FilterNames } from '../../helpers/common-helper'
import { ConfigHelper } from '../../helpers/config-helper'
import { DeviceConnectionMarkerIcon } from '../../models/custom/device-connection-marker-icon'
import { Dictionary, KeyType } from '../../helpers/dictionary'
import { Enums } from '../../models/common/enums'
import { GetViewColumnOptions } from '../../models/core/op-view'
import { GridTypes, GridController } from '../common/grid/grid.controller'
import { ImportOptions } from '../common/import/import.directive'
import { LocalizationHelper } from '../../helpers/localization-helper'
import { LoggerService } from './../common/common.module'
import { Map, MapOptions, MapLegendItem } from '../common/map2/map.directive.controller'
import { OpDeviceConnection } from '../../models/dw/op-device-connection'
import { OpDeviceType } from '../../models/core/op-device-type'
import { OpFile } from '../../models/core/op-file';
import { OpMarker, OpCoord, OpRange } from '../../models/custom/op-map-area'
import { OpView } from '../../models/core/op-view';
import { OpViewColumn } from '../../models/core/op-view-column'
import { TemplateHelper } from '../../helpers/template-helper'
import { DataProvider } from '../../helpers/data-provider'
import { OpBounds } from '../../models/custom/op-map-area'
import { ExportOptions } from '../common/export';
import { SystemService, DetailsOptions } from '../../services/system'
import { UserSessionService } from '../../services/user-session'
import { GridContextMenuService } from "../../services/grid"

interface DeviceconnetionsScope
    extends ScopeBaseGridsterGrid {
    showParentDetails: any
}

export class DeviceConnectionsController
    extends BaseGridGridsterController {
    private grid: GridController<OpDeviceConnection>
    private static get DefaultBlueRadioIcon() { return 'images/blue_radio.png' }
    private static get DefaultGreyRadioIcon() { return 'images/grey_radio.png' }
    private static get DefaultRedHubIcon() { return 'images/red_hub.png' }

    private latitudeFieldName: string
    private longitudeFieldName: string

    private parentLatitudeFieldName: string
    private parentLongitudeFieldName: string

    private serialNbrFieldName: string
    private parentSerialNbrFieldName: string

    private helperTimeFieldName: string

    private moduleName: Enums.SimaxModuleName
    private idDeviceTypeMarkerIcon: Dictionary<DeviceConnectionMarkerIcon[]>

    public constructor(
        protected $scope: DeviceconnetionsScope,
        protected $state: StateService,
        $timeout: ng.ITimeoutService,
        protected api: Api,
        private logger: LoggerService,
        protected localDictionary: LocalDictionaryFactory,
        private gridContextMenuService: GridContextMenuService,
        protected userSession: UserSessionService,
        protected systemService: SystemService,
        referenceType: Enums.ReferenceType,
        moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, CommonHelper.IdDeviceConnection, null, 'DEVICECONNECTIONS', referenceType, true)

        this.moduleName = moduleName

        this.setEvents()
        this.setMainGridOptions()
    }

    public onInitialized(e: any, grid: GridController<OpDeviceConnection>): void {

        // Ten null jest tu umyślnie
        this.idDeviceTypeMarkerIcon = null

        let activeView: OpView = this.userSession.getDataProvider().View.getActiveViewLocal(Enums.ReferenceType.IdDeviceConnection)

        if (activeView) {

            let getViewColumnHelperTime: GetViewColumnOptions = new GetViewColumnOptions(DataType.HELPER_TIME);
            getViewColumnHelperTime.viewColumnType = ViewColumnType.BaseHelper
            let vcHelperTime: OpViewColumn = activeView.getViewColumn(getViewColumnHelperTime)

            if (vcHelperTime) {
                this.helperTimeFieldName = vcHelperTime.name.toLowerCase()
            }

            var getViewColumnSNParameters: GetViewColumnOptions = new GetViewColumnOptions(DataType.HELPER_SERIAL_NBR)
            getViewColumnSNParameters.viewColumnType = ViewColumnType.BaseHelper

            let snColumnn: OpViewColumn = activeView.getViewColumn(getViewColumnSNParameters)

            if (snColumnn) {
                this.serialNbrFieldName = snColumnn.name.toLowerCase()

                let getViewColumnParameters: GetViewColumnOptions = new GetViewColumnOptions(DataType.HELPER_ID_LOCATION)
                getViewColumnParameters.viewColumnType = ViewColumnType.BaseHelper
                getViewColumnParameters.keyColumn = snColumnn

                let idLocationSnColumnn: OpViewColumn = activeView.getViewColumn(getViewColumnParameters)

                if (idLocationSnColumnn) {
                    // lat
                    let getViewColumnLatLonParameters: GetViewColumnOptions = new GetViewColumnOptions(DataType.LOCATION_LATITUDE)
                    getViewColumnLatLonParameters.viewColumnType = ViewColumnType.Standard
                    getViewColumnLatLonParameters.keyColumn = idLocationSnColumnn

                    let latCol: OpViewColumn = activeView.getViewColumn(getViewColumnLatLonParameters)
                    if (latCol) {
                        this.latitudeFieldName = latCol.name.toLowerCase()
                    }

                    // lon
                    getViewColumnLatLonParameters.idDataType = DataType.LOCATION_LONGITUDE
                    let lonCol: OpViewColumn = activeView.getViewColumn(getViewColumnLatLonParameters)

                    if (lonCol) {
                        this.longitudeFieldName = lonCol.name.toLowerCase()
                    }
                }
            }

            let snParentColumn: OpViewColumn = activeView.getViewColumn(new GetViewColumnOptions(DataType.HELPER_SERIAL_NBR_PARENT))

            if (snParentColumn) {
                this.parentSerialNbrFieldName = snParentColumn.name.toLowerCase()

                let getViewColumnParameters: GetViewColumnOptions = new GetViewColumnOptions(DataType.HELPER_ID_LOCATION)
                getViewColumnParameters.viewColumnType = ViewColumnType.BaseHelper
                getViewColumnParameters.keyColumn = snParentColumn

                let idLocationSnColumnn: OpViewColumn = activeView.getViewColumn(getViewColumnParameters)

                if (idLocationSnColumnn) {
                    // lat
                    let getViewColumnLatLonParameters: GetViewColumnOptions = new GetViewColumnOptions(DataType.LOCATION_LATITUDE)
                    getViewColumnLatLonParameters.viewColumnType = ViewColumnType.Standard
                    getViewColumnLatLonParameters.keyColumn = idLocationSnColumnn

                    let latCol: OpViewColumn = activeView.getViewColumn(getViewColumnLatLonParameters)
                    if (latCol) {
                        this.parentLatitudeFieldName = latCol.name.toLowerCase()
                    }

                    // lon
                    getViewColumnLatLonParameters.idDataType = DataType.LOCATION_LONGITUDE

                    let lonCol: OpViewColumn = activeView.getViewColumn(getViewColumnLatLonParameters)
                    if (lonCol) {
                        this.parentLongitudeFieldName = lonCol.name.toLowerCase()
                    }
                }
            }

            if (!this.latitudeFieldName
                || !this.longitudeFieldName
                || !this.parentLatitudeFieldName
                || !this.parentLongitudeFieldName) {
                console.log("Missing latitude/longitude columns!")
            }

            if (!this.serialNbrFieldName) {
                console.log("Missing serialNbr column!")
            }

            if (!this.parentSerialNbrFieldName) {
                console.log("Missing parentSerialNbr column!")
            }

        } else {
            console.log("Missing device connection view!")
        }

        this.dataGrid = e.component
        this.grid = grid;

        this.setGridId(e.tableId)
        this.onGridInit(e.tableId)

    }

    public onAdd(): void {

    }

    public onEdit(): void {

    }

    public onShowDetails(e: any, keyField: string): void {
        let selectedObjects: any[] = this.dataGrid.getSelectedRowsData()
        let anyObjectsSelected: boolean = selectedObjects && selectedObjects.length > 0

        let objectIds: number[] = []
        if (anyObjectsSelected) {
            objectIds = selectedObjects.map(x => x[keyField])
        }

        if (!e) {
            e = {}
        }

        if (!e.data) {

            e.data = anyObjectsSelected ? selectedObjects[0] : {}
        }

        const serialNbr = e.data[keyField]

        if (serialNbr != null) {
            const detailsOptions: DetailsOptions = {
                idReferenceType: Enums.ReferenceType.SerialNbr,
                moduleName: Enums.SimaxModuleName.Device,
                referenceObjectId: serialNbr
            }

            this.showDetails(e, detailsOptions)
        }
    }

    public onDelete(): void {

    }

    public onDeleted(): void {

    }

    public onConfirmDelete(): void {

    }

    public onDoubleClick(e: any): void {
        this.$scope.showDetails(e)
    }

    public onShowDevices(keyColumnName: string): void {

        let dataRows: any[] = this.dataGrid.getSelectedRowsData();

        if (dataRows && dataRows.length > 0) {

            let dataRow: any = dataRows[0]

            if (keyColumnName) {

                let serialNbr: number = +dataRow[keyColumnName]

                if (!serialNbr || isNaN(serialNbr)) {

                    if (keyColumnName == this.parentSerialNbrFieldName) {
                        CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoHub), 'info', 5000)
                    }

                } else {

                    this.addCustomGridFilter([keyColumnName, '=', serialNbr])

                }

            } else {

                console.log("onShowDevices - Missing key column")

            }
        }
    }

    public getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items = this.gridContextMenuService.getContextMenuItemsByReferenceType(Enums.ReferenceType.IdDeviceConnection, {
            idReferenceTypes: this.grid.selectedItemsIds,
            showParentDetails: () => this.$scope.showParentDetails(),
            showDetails: (e: any) => this.$scope.showDetails(e),
            onShowDevices: () => this.onShowDevices(this.serialNbrFieldName),
            onShowParentDevices: () => this.onShowDevices(this.parentSerialNbrFieldName),
        })

        return items
    }

    public getMarkerIconsAndMapLegend(): JQueryPromise<any> {
        const defer = $.Deferred<Dictionary<DeviceConnectionMarkerIcon[]>>()

        if (this.idDeviceTypeMarkerIcon) {
            defer.resolve(this.idDeviceTypeMarkerIcon)
        } else {
            this.userSession.getDataProvider().DeviceConnection.deviceConnectionMapMarkerConfiguration()
                .then((resultMarkerIcons: DeviceConnectionMarkerIcon[]) => {
                    this.idDeviceTypeMarkerIcon = new Dictionary<DeviceConnectionMarkerIcon[]>(null, KeyType.Number)

                    for (var item of resultMarkerIcons) {
                        for (var idDeviceType of item.idDeviceType) {
                            if (!this.idDeviceTypeMarkerIcon.containsKey(idDeviceType)) {
                                this.idDeviceTypeMarkerIcon.add(idDeviceType, [])
                            }

                            this.idDeviceTypeMarkerIcon.tryGetValue(idDeviceType).push(item)
                        }
                    }
                    defer.resolve(this.idDeviceTypeMarkerIcon)
                    // map legend
                    this.setMapLegend(resultMarkerIcons)
                })
        }

        return defer.promise()
    }

    public setMapLegend(resultMarkerIcons: DeviceConnectionMarkerIcon[]) {
        const legendItems: MapLegendItem[] = []
        const iconDict: string[] = []
        resultMarkerIcons.forEach((deviceConnectionMarkerIcon: DeviceConnectionMarkerIcon, markerIconIndex: number) => {
            deviceConnectionMarkerIcon.deviceType.forEach((deviceType: OpDeviceType, deviceTypeIndex: number) => {
                const description: string = deviceType.toString() + ' (' + deviceConnectionMarkerIcon.toString() + ')'

                let iconBase64: string = null
                if (typeof deviceConnectionMarkerIcon.icon.fileBytes !== "string") {
                    iconBase64 = CommonHelper.bin2String(<number[]>deviceConnectionMarkerIcon.icon.fileBytes)
                } else {
                    iconBase64 = <string>deviceConnectionMarkerIcon.icon.fileBytes
                }

                legendItems.push({
                    iconId: markerIconIndex,
                    description,
                    color: null,
                    icon: iconBase64
                })
            })
        })

        this.getGridsterMap()
            .then((map: Map) => {
                map.setLegend(legendItems)
            })
    }

    public getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,

            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_LIST) ? "['" + Activity[Activity.DEVICE_LIST] + "']" : null,
            exportPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_CONNECTION_EXPORT_OP) ? "['" + Activity[Activity.DEVICE_CONNECTION_EXPORT_OP] + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,

            onShowClick: () => { this.$scope.showDetails({ data: this.dataGrid.getSelectedRowsData()[0] }) },
            onShowMap: () => { return this.showMapDetails() },
            addIssueMultiple: true,
            addTaskMultiple: true
        }

    }

    public getExportOptions(): ExportOptions {
        return {
            referenceType: this.referenceType,
            pluginOptions: {
                moduleName: this.moduleName,
                popupName: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EXPORT, this.moduleName)
            }
        }
    }

    public getImportOptions(): ImportOptions {
        return {
            dictionaryMethodName: 'getDeviceConnectionImportParams',
            popupName: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ImportDeviceConnections),
            requestMethodType: 'deviceconnections',
            referenceType: this.referenceType,
            moduleName: this.moduleName,
            columnsReorderingDisabled: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP, Enums.UIObjectProperties.DeviceConnectionModuleMainGrid)
        }
    }

    public setEvents(): void {
        this.$scope.showDetails = (e) => { this.onShowDetails(e, this.serialNbrFieldName) }
        this.$scope.showParentDetails = (e) => { this.onShowDetails(e, this.parentSerialNbrFieldName) }
    }

    public setMainGridOptions(): void {
        const dataProvider: DataProvider = this.userSession.getDataProvider()
        dataProvider.System.getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, this.moduleName).then(columns => {
            dataProvider.System.getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, this.moduleName).then(defaultColumns => {
                this.$scope.mainGridOptions = {
                    referenceId: this.referenceType,
                    type: GridTypes.MAIN,
                    name: 'DeviceConnectionsGrid',
                    exportMethod: 'deviceConnections',
                    defaultColumnsDictionary: defaultColumns,
                    columnsDictionary: columns,
                    addCustomFilters: true,
                    preExecuteClearFilter: this.preExecuteGridClearFilter,
                    allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.SimCardModuleMainGrid),
                    contextMenuItems: (isTouchScreen: boolean = false) => { return this.getContextMenuItems(isTouchScreen) },
                    buttonsOptions: this.getGridButtonsOptions(),
                    getDataSourceMethod: this.userSession.getDataProvider().DeviceConnection.getDeviceConnectionFilter,
                    importOptions: this.getImportOptions(),
                    exportOptions: this.getExportOptions(),
                    onInitialized: (e: any, grid: GridController<OpDeviceConnection>) => { this.onInitialized(e, grid) },
                    onDataReady: data => { this.getMarkerIconsAndMapLegend().then(() => { this.onDataReady(data) }) },
                    onSelectionChanged: e => { this.onSelectionChanged(e) },
                    onRowDoubleClick: e => { this.onDoubleClick(e) },
                    onUpdateGridsterPosition: e => { this.setGridsterPosition(e) }
                }
            })
        })
    }

    // Przygotowanie markerów
    protected getMarkers(data: any[], map: Map, selected: boolean): OpMarker[] {

        var markers: OpMarker[] = []
        var ranges: OpRange[] = []

        // Validate
        if (!this.serialNbrFieldName
            || !this.parentSerialNbrFieldName
            || !this.latitudeFieldName
            || !this.longitudeFieldName
            || !this.parentLatitudeFieldName
            || !this.parentLongitudeFieldName
            || !this.idDeviceTypeMarkerIcon
        ) {
            return markers
        }

        // Prepare 
        var childMarkers: OpMarker[] = []
        var parentMarkers: OpMarker[] = []

        var parentDevicesRowIds: Dictionary<number[]> = new Dictionary<number[]>(null, KeyType.Number)
        var childDevicesRowIds: Dictionary<number[]> = new Dictionary<number[]>(null, KeyType.Number)
        var idRowRow: Dictionary<any> = new Dictionary<any>(null, KeyType.Number);

        data.forEach(dataRow => {
            let id: number = +dataRow.id
            let serialNbr: number = +dataRow[this.serialNbrFieldName]
            let parentSerialNbr: number = +dataRow[this.parentSerialNbrFieldName]

            idRowRow.addOrUpdate(id, dataRow)

            if (serialNbr && !childDevicesRowIds.containsKey(serialNbr)) {
                childDevicesRowIds.add(serialNbr, [])
            }

            if (parentSerialNbr && !parentDevicesRowIds.containsKey(parentSerialNbr)) {
                parentDevicesRowIds.add(parentSerialNbr, [])
            }

            childDevicesRowIds.tryGetValue(serialNbr).push(id)
            const parentDeviceCollection: number[] = parentDevicesRowIds.tryGetValue(parentSerialNbr)
            if (parentDeviceCollection != null) {
                parentDeviceCollection.push(id)
            }
        });

        var proceededParentSerialNbr: number[] = []

        // Generate child markers with related parent markers
        for (var keySerialNbr of childDevicesRowIds.keys()) {

            var serialNbr: number = +keySerialNbr
            let idRows: number[] = childDevicesRowIds.tryGetValue(serialNbr)

            // Generate marker for device
            if (idRows && idRows.length > 0) {
                let row: any = idRowRow.tryGetValue(idRows[0])

                let keyMarker: OpMarker = new OpMarker()
                keyMarker.coords = this.dataRowToOpCoord(row, this.latitudeFieldName, this.longitudeFieldName)
                keyMarker.relatedMarkers = []
                keyMarker.referenceValue = serialNbr

                keyMarker.onClick = (element: OpMarker) => {
                    this.onMarkerClick(idRows)
                }

                childMarkers.push(keyMarker)
                markers.push(keyMarker)

                for (var idRow of idRows) {

                    row = idRowRow.tryGetValue(idRow)

                    let parentSerialNbr: number = +row[this.parentSerialNbrFieldName]

                    if (parentSerialNbr) {

                        let parentMarker: OpMarker = null;

                        if (proceededParentSerialNbr.every(x => x != parentSerialNbr)) {

                            proceededParentSerialNbr.push(parentSerialNbr)

                            parentMarker = new OpMarker()
                            parentMarker.coords = this.dataRowToOpCoord(row, this.parentLatitudeFieldName, this.parentLongitudeFieldName)
                            parentMarker.referenceValue = parentSerialNbr
                            parentMarker.relatedMarkers = []

                            let parentIdRows: number[] = parentDevicesRowIds.tryGetValue(parentSerialNbr)

                            parentMarker.onClick = (element: OpMarker) => {
                                this.onMarkerClick(parentIdRows)
                            }

                            parentMarkers.push(parentMarker)
                            markers.push(parentMarker)

                        } else {
                            let filteredMarkers: OpMarker[] = markers.filter(x => x.referenceValue == parentSerialNbr)
                            if (filteredMarkers && filteredMarkers.length > 0) {
                                parentMarker = filteredMarkers[0]
                            }
                        }

                        if (parentMarker) {
                            keyMarker.relatedMarkers.push(parentMarker)
                            parentMarker.relatedMarkers.push(keyMarker)
                        }
                    }
                }
            }
        }

        // Child tooltips
        for (var marker of childMarkers) {

            let serialNbr: number = +marker.referenceValue

            if (!isNaN(serialNbr)) {

                let idRows: number[] = childDevicesRowIds.tryGetValue(serialNbr)

                if (idRows && idRows.length > 0) {

                    let row: any = idRowRow.tryGetValue(idRows[0])

                    if (row) {

                        let markerProperties: { iconUrl: string, iconFile: OpFile, tooltip: string } = this.getChildMarkerProperties(marker, row, map)

                        marker.tooltip = markerProperties.tooltip
                        marker.iconURL = markerProperties.iconUrl

                        if (markerProperties.iconFile && markerProperties.iconFile.fileBytes && markerProperties.iconFile.fileBytes.length > 0) {
                            if (typeof markerProperties.iconFile.fileBytes !== "string") {
                                markerProperties.iconFile.fileBytes = CommonHelper.bin2String(<number[]>markerProperties.iconFile.fileBytes)
                            }
                            marker.iconImage = markerProperties.iconFile.fileBytes.toString()
                        }

                    }
                }
            }
        }

        // Parent tooltips, ranges
        for (var marker of parentMarkers) {

            let serialNbr: number = +marker.referenceValue

            if (!isNaN(serialNbr)) {

                let idRows: number[] = parentDevicesRowIds.tryGetValue(serialNbr)

                if (idRows && idRows.length > 0) {

                    let rows: any[] = idRows.map(x => idRowRow.tryGetValue(x))

                    if (rows) {

                        let markerProperties: { iconUrl: string, iconFile: OpFile, tooltip: string, inactiveRange: number } = this.getParentMarkerProperties(marker, rows, map)

                        marker.iconURL = markerProperties.iconUrl
                        marker.tooltip = markerProperties.tooltip

                        if (markerProperties.iconFile && markerProperties.iconFile.fileBytes && markerProperties.iconFile.fileBytes.length > 0) {
                            if (typeof markerProperties.iconFile.fileBytes !== "string") {
                                markerProperties.iconFile.fileBytes = CommonHelper.bin2String(<number[]>markerProperties.iconFile.fileBytes)
                            }
                            marker.iconImage = markerProperties.iconFile.fileBytes.toString()
                        }

                        // Jeśli jest także jako child
                        if (childDevicesRowIds.containsKey(serialNbr)) {

                            let idChildRows: number[] = childDevicesRowIds.tryGetValue(serialNbr)

                            if (idChildRows && idChildRows.length > 0) {

                                let childRow: any = idRowRow.tryGetValue(idChildRows[0])
                                let childMarkerProperties: { iconUrl: string, tooltip: string } = this.getChildMarkerProperties(marker, childRow, map)

                                marker.tooltip = `${marker.tooltip}<hr/>${childMarkerProperties.tooltip}`

                            }
                        }

                        if (marker.relatedMarkers && marker.relatedMarkers.length > 0) {

                            let range: OpRange = new OpRange()
                            range.referenceValue = marker.referenceValue
                            range.radius = markerProperties.inactiveRange
                            range.coords = marker.coords
                            range.tooltip = null
                            range.lineColor = '#33cc33'
                            range.lineOpacity = 0.8
                            range.lineWeight = 1
                            range.fillColor = '#33cc33'
                            range.fillOpacity = 0.1

                            range.selectedLineColor = '#248f24'
                            range.selectedLineWeight = 2.0
                            range.selectedFillOpacity = 0.20

                            ranges.push(range)

                        }
                    }
                }
            }
        }

        if (!selected) {
            map.setRanges(ranges)
        }

        return markers
    }

    private getChildMarkerProperties(marker: OpMarker, markerRow: any, map: Map)
        : { iconUrl: string, iconFile: OpFile, tooltip: string } {

        let tooltip: string = ''
        let icon: string = DeviceConnectionsController.DefaultBlueRadioIcon
        let iconFile: OpFile = null

        let timeStr: string = '-'

        if (this.helperTimeFieldName) {
            let time: any = markerRow[this.helperTimeFieldName]
            if (time) {

                timeStr = moment(time).format(window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS'))

            }
        }

        if (marker.relatedMarkers) {

            let dcItem: OpDeviceConnection = this.grid.getSourceObject(markerRow)
            let markerIcons: DeviceConnectionMarkerIcon[] = null

            if (dcItem) {
                let idDeviceType: number = dcItem.idDeviceType
                markerIcons = this.idDeviceTypeMarkerIcon.tryGetValue(idDeviceType)
            }

            if (marker.relatedMarkers.length == 0) {

                // 0 parent devices

                if (markerIcons) {

                    let filteredMarkers: DeviceConnectionMarkerIcon[] = markerIcons.filter(x => x.state == Enums.DeviceConnectionMarkerState.NotRetransmitted)

                    if (filteredMarkers && filteredMarkers.length > 0) {
                        iconFile = filteredMarkers[0].icon
                    }
                }

                icon = DeviceConnectionsController.DefaultGreyRadioIcon

                tooltip = `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr)}: ${marker.referenceValue.toString()}`
                    + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FillingDate)}: ${timeStr}`

            } else {

                if (markerIcons) {

                    let filteredMarkers: DeviceConnectionMarkerIcon[] = markerIcons.filter(x => x.state == Enums.DeviceConnectionMarkerState.Retransmitted)

                    if (filteredMarkers && filteredMarkers.length > 0) {
                        iconFile = filteredMarkers[0].icon
                    }

                }

                icon = DeviceConnectionsController.DefaultBlueRadioIcon

                if (marker.relatedMarkers.length == 1) {

                    // 1 parent device

                    let range: number = map.computeDistanceBetweenCoords(marker.relatedMarkers[0].coords, marker.coords)

                    tooltip = `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr)}: ${marker.referenceValue.toString()}`
                        + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Distance)}: ${range.toFixed(2)} m`
                        + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FillingDate)}: ${timeStr}`

                } else {

                    // more than 1 parent device

                    var parentSerialNbrs: string = ''

                    marker.relatedMarkers.forEach(parent => {
                        let range: number = map.computeDistanceBetweenCoords(parent.coords, marker.coords)
                        parentSerialNbrs = parentSerialNbrs.concat("<br> ", parent.referenceValue.toString(), ": ", range.toFixed(2), " m")
                    })

                    tooltip = `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr)}: ${marker.referenceValue.toString()}`
                        + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FillingDate)}: ${timeStr}`
                        + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MultipleParentDevices)}: ${parentSerialNbrs}`

                }

            }
        }

        return { iconUrl: icon, iconFile: iconFile, tooltip: tooltip }
    }

    private getParentMarkerProperties(marker: OpMarker, markerRows: any[], map: Map)
        : { iconUrl: string, iconFile: OpFile, tooltip: string, inactiveRange: number } {
        var maxRange: number = 0
        var minRange: number = Number.MAX_VALUE

        var parentLatLng: OpCoord = marker.coords

        marker.relatedMarkers.forEach(child => {
            var childLatLng: OpCoord = child.coords

            var range: number = map.computeDistanceBetweenCoords(childLatLng, parentLatLng)

            if (maxRange < range) {
                maxRange = range
            }

            if (minRange > range) {
                minRange = range
            }
        })

        let maxMapDeviceConnectionRange: number = ConfigHelper.getValue(Enums.SimaxConfigSection.Map, ConfigHelper.Key.MaxMapDeviceConnectionOKORange)

        var inactiveRange: number = maxRange
        if (inactiveRange >= maxMapDeviceConnectionRange) {
            inactiveRange = maxMapDeviceConnectionRange
        }

        var inactive: number = 0
        var active: number = 0

        let inactiveText: string = "-"

        if (this.latitudeFieldName && this.longitudeFieldName && markerRows) {
            markerRows.forEach(row => {
                if (!row[this.parentSerialNbrFieldName]) {
                    var gChild: OpCoord = new OpCoord()
                    gChild.latitude = row[this.latitudeFieldName]
                    gChild.longitude = row[this.longitudeFieldName]
                    var range: number = map.computeDistanceBetweenCoords(parentLatLng, gChild)
                    if (range < inactiveRange) {
                        inactive = inactive + 1
                    }
                }
            })

            inactiveText = inactive.toString()
        }

        var icon: string = DeviceConnectionsController.DefaultRedHubIcon
        let iconFile: OpFile = null
        var tooltip: string = `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr)}: ${marker.referenceValue}`
            + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MaxRange)}: ${maxRange.toFixed(2)} m`
            + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MinRange)}: ${minRange.toFixed(2)} m`
            + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ActiveDevices)}: ${marker.relatedMarkers.length}`
            + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InactiveDevices)}: ${inactiveText}`

        if (markerRows && markerRows.length > 0) {

            let dcItem: OpDeviceConnection = this.grid.getSourceObject(markerRows[0])
            let markerIcons: DeviceConnectionMarkerIcon[] = null

            if (dcItem) {
                let idDeviceType: number = dcItem.idDeviceTypeParent
                markerIcons = this.idDeviceTypeMarkerIcon.tryGetValue(idDeviceType)
            }

            if (markerIcons) {

                let filteredMarkers: DeviceConnectionMarkerIcon[] = null;

                if (marker.relatedMarkers && marker.relatedMarkers.length > 0) {
                    filteredMarkers = markerIcons.filter(x => x.state == Enums.DeviceConnectionMarkerState.Retransmitted)
                } else {
                    filteredMarkers = markerIcons.filter(x => x.state == Enums.DeviceConnectionMarkerState.NotRetransmitted)
                }

                if (filteredMarkers && filteredMarkers.length > 0) {
                    iconFile = filteredMarkers[0].icon
                }

            }
        }

        var tooltip: string = `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr)}: ${marker.referenceValue}`
            + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MaxRange)}: ${maxRange.toFixed(2)} m`
            + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MinRange)}: ${minRange.toFixed(2)} m`
            + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ActiveDevices)}: ${marker.relatedMarkers.length}`
            + `<br>${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InactiveDevices)}: ${inactiveText}`

        return { iconUrl: icon, iconFile: iconFile, tooltip: tooltip, inactiveRange: inactiveRange }
    }

    private dataRowToOpCoord(dataRow: any, latFieldName: string, lonFieldName: string): OpCoord {
        let pos: OpCoord = null

        let latitude: number = +dataRow[latFieldName]
        let longitude: number = +dataRow[lonFieldName]

        if (!isNaN(latitude) && !isNaN(longitude)) {
            pos = new OpCoord()
            pos.latitude = latitude
            pos.longitude = longitude
        }

        return pos
    }


    // BaseGridGridsterController Implementation

    protected onGridsterMapConfiguration(mapOptions: MapOptions): void {
        mapOptions.enableAreaSelect = true

        mapOptions.onAreaSelect = (bounds: OpBounds) => {
            if (this.latitudeFieldName != null && this.longitudeFieldName != null) {
                this.addCustomGridFilter(CommonHelper.getLonLatFilter(bounds, this.latitudeFieldName, this.longitudeFieldName, FilterNames.DeviceConnectionsByLocations))
            }
        }
    }

    // BaseGridGridsterController Implementation End
}
